import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddHeartRunnerComponent from '../components/addHeartRunnerComponent';
import { fetchHeartRunnerOrg,insertHeartRunner, getCountryListFunc,getRegionListFunc,getPermissionsListFunc } from '../actions/heartRunnerAction';

class AddSubAdminContainer extends Component {
   

    componentWillMount() {
        // if (this.props.login.authTokenId !== undefined || this.props.login.authTokenId !== "") {
        //     if (loggedIn(this.props.login.authTokenId)) {
                this.props.actions.fetchHeartRunnerOrg(this.props.dispatch)

              
        //     }
        //     else {
        //         logout();
        //         this.props.actions.logOutAdmin();
        //         this.props.history.push('/adminLogin');
        //     }
        // }
        // else {
        //     logout();
        //     this.props.history.push('/adminLogin');
        // }
    }
    componentDidMount() {
        this.props.actions.getCountryListFunc(
        this.props.dispatch)
         this.props.actions.getRegionListFunc(
        this.props.dispatch)
        this.props.actions.getPermissionsListFunc(
            this.props.dispatch
        )
    }
    addHeartRunner =(heartRunnerformData)=> {
        //console.log(heartRunnerformData)
        this.props.actions.insertHeartRunner(
            heartRunnerformData,
            this.props.dispatch
        )
    }



    render() {
        
        return (
            <div>
            
               <AddHeartRunnerComponent 
                    addHeartRunnerDetails={this.props.addHeartRunnerDetails} 
                    addHeartRunner={this.addHeartRunner} 
               
               />                    
            </div>  

        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            insertHeartRunner,
            fetchHeartRunnerOrg,
            getCountryListFunc,
            getRegionListFunc,
            getPermissionsListFunc
            //updateRedirectMessageSuccess
            //logOutAdmin, addDeviceDetail, fetchOrganizationList, fetchRoleList
        }, dispatch)
    };
};

function mapStateToProps({superAdminLoginReducer, heartRunnerReducer }) {
    console.log(heartRunnerReducer)
    return {
        addHeartRunnerDetails: {
            isLoading: heartRunnerReducer.isLoading,
            messageLabel: heartRunnerReducer.messageLabel,
            errorNumber: heartRunnerReducer.errorNumber,
            errorMessage: heartRunnerReducer.errorMessage,
            statusCode: heartRunnerReducer.statusCode,
            heartRunnerOrgInfo:heartRunnerReducer.heartRunnerOrgInfo,
            countryList : heartRunnerReducer.countryList,
            regionList : heartRunnerReducer.regionList,
            permissionList:heartRunnerReducer.permissionList
        },
        login: {
            authTokenId: superAdminLoginReducer.authTokenId,
            adminId: superAdminLoginReducer.adminId,
            organizationId: superAdminLoginReducer.organizationId
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddSubAdminContainer))